import { useState, useEffect } from 'react';

/**
 * Detects if the user is on an actual mobile device (iOS/Android)
 * vs just a small screen on desktop.
 * 
 * This checks both user agent AND touch capability for accuracy.
 */
export function useIsMobileDevice() {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const checkMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as unknown as { opera?: string }).opera || '';
      
      // Check for iOS devices
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as unknown as { MSStream?: unknown }).MSStream;
      
      // Check for Android devices
      const isAndroid = /android/i.test(userAgent);
      
      // Also check for touch capability as a secondary signal
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Consider it a mobile device if it matches iOS/Android user agent
      // AND has touch capability (to filter out desktop browsers spoofing user agent)
      setIsMobileDevice((isIOS || isAndroid) && hasTouchScreen);
    };

    checkMobileDevice();
    
    // No need to listen for changes - device type doesn't change during session
  }, []);

  return isMobileDevice;
}

/**
 * Returns the mobile OS type if on a mobile device
 */
export function getMobileOS(): 'ios' | 'android' | null {
  if (typeof navigator === 'undefined') return null;
  
  const userAgent = navigator.userAgent || navigator.vendor || '';
  
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'ios';
  }
  
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  return null;
}

